import { useActiveAccount } from '..';

export default function ShowForTypes({ types, children }) {
  const { showForTypes } = useActiveAccount();

  return showForTypes(types) ? children : null;
}
